unable to read source [project]/workspace/frontend/src/core/removeShowElement.ts